import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useActivityStore = defineStore('activity', () => {
  // State
  const isLoggedIn = ref(false)
  const tick = ref(2000)
  const specifyActivities = ref([4, 29, 34])
  const activitiesDetailList = ref([])
  const loggedInActivityList = ref([])
  const publicActivityList = ref([]) // 未登入時的活動列表（SSR 快取用）
  const promotionList = ref([])
  const activityMap = ref({})
  const tournamentList = ref([])
  const refs = ref({})
  const siteConfig = ref({})
  const isPlaying = ref(false)
  const loading = ref(false)
  const error = ref(null)
  const refreshTimer = ref(null)
  const activeInstances = ref(new Set())
  const friendsActivityDetail = ref(null)
  const fetchPromise = ref(null)

  // Getters
  const getTick = computed(() => tick.value)
  const getSpecifyActivities = computed(() => specifyActivities.value)
  const getActivitiesDetailList = computed(() => activitiesDetailList.value)
  const getLoggedInActivityList = computed(() => loggedInActivityList.value)
  const getPublicActivityList = computed(() => publicActivityList.value)
  // 根據登入狀態切換活動列表
  const activityList = computed(() => (isLoggedIn.value ? loggedInActivityList.value : publicActivityList.value))
  const getPromotionList = computed(() => promotionList.value)
  const getActivityMap = computed(() => activityMap.value)
  const getTournamentList = computed(() => tournamentList.value)
  const getRefs = computed(() => refs.value)
  const getSiteConfig = computed(() => siteConfig.value)
  const getIsPlaying = computed(() => isPlaying.value)
  const getLoading = computed(() => loading.value)
  const getError = computed(() => error.value)
  const getRefreshTimer = computed(() => refreshTimer.value)
  const getActiveInstances = computed(() => activeInstances.value)
  const getActiveInstancesCount = computed(() => activeInstances.value.size)
  const getFriendsActivityDetail = computed(() => friendsActivityDetail.value)
  const getFriendActivity = computed(() => activityList.value.find((item) => item.activityType === 20))
  // 負責處理Footbar中邀請好友活動按鈕的顯示與否 避免因資料切換而產生畫面跳動
  const hasFriendActivity = computed(() => publicActivityList.value.find((item) => item.activityType === 20))
  
  // Actions
  function setIsLoggedIn(data) {
    isLoggedIn.value = data
  }

  function setTick(data) {
    tick.value = data
  }

  function setSpecifyActivities(data) {
    specifyActivities.value = data
  }

  function setActivitiesDetailList(data) {
    activitiesDetailList.value = data
  }

  function setLoggedInActivityList(data) {
    loggedInActivityList.value = data
  }

  function setPublicActivityList(data) {
    publicActivityList.value = data
  }

  function setPromotionList(data) {
    promotionList.value = data
  }

  function setActivityMap(data) {
    activityMap.value = data
  }

  function setTournamentList(data) {
    tournamentList.value = data
  }

  function setRefs(data) {
    refs.value = data
  }

  function setSiteConfig(data) {
    siteConfig.value = data
  }

  function setIsPlaying(data) {
    isPlaying.value = data
  }

  function setLoading(data) {
    loading.value = data
  }

  function setError(data) {
    error.value = data
  }

  function setRefreshTimer(data) {
    refreshTimer.value = data
  }

  function registerInstance(instanceId) {
    activeInstances.value.add(instanceId)
  }

  function unregisterInstance(instanceId) {
    activeInstances.value.delete(instanceId)
  }

  function setFriendsActivityDetail(data) {
    friendsActivityDetail.value = data
  }

  return {
    // State
    tick,
    specifyActivities,
    activitiesDetailList,
    loggedInActivityList,
    publicActivityList,
    promotionList,
    activityMap,
    tournamentList,
    refs,
    siteConfig,
    isPlaying,
    loading,
    error,
    refreshTimer,
    activeInstances,
    friendsActivityDetail,
    fetchPromise,

    // Getters
    getTick,
    getSpecifyActivities,
    getActivitiesDetailList,
    getLoggedInActivityList,
    getPublicActivityList,
    activityList,
    getPromotionList,
    getActivityMap,
    getTournamentList,
    getRefs,
    getSiteConfig,
    getIsPlaying,
    getLoading,
    getError,
    getRefreshTimer,
    getActiveInstances,
    getActiveInstancesCount,
    getFriendsActivityDetail,
    getFriendActivity,
    hasFriendActivity,

    // Actions
    setIsLoggedIn,
    setTick,
    setSpecifyActivities,
    setActivitiesDetailList,
    setLoggedInActivityList,
    setPublicActivityList,
    setPromotionList,
    setActivityMap,
    setTournamentList,
    setRefs,
    setSiteConfig,
    setIsPlaying,
    setLoading,
    setError,
    setRefreshTimer,
    registerInstance,
    unregisterInstance,
    setFriendsActivityDetail,
  }
})
